const action = require('../action/action');

const popupEdit = Object.assign({}, action, {
    modal: false,
    act: async function () {
        if (this.disabled) {
            return false;
        }

        this.element.setAttribute("data-zit-indicator", "on");

        if (this.modal === false) {
            await this.createModal();
        }

        this.modal.open();

        this.element.removeAttribute("data-zit-indicator");
    },

    createModal: async function () {
        let formId = 'popupEditForm_' + this.id;
        formId = formId.replace(this.formId + '_', '');

        let formPostData = {
            csrf: this.hm.app.pageToken,
            formId: formId
        };

        if (this.itemId !== null) {
            formPostData.id = this.itemId;
        }

        formPostData = Object.assign({}, formPostData, this.postParams);

        //this.hm.log('create modal', this.controller, this.action, formPostData);

        let response = await this.hm.app.fetchJson(this.controller, this.action, formPostData, 'POST');

        this.modal = this.hm.newComponent('modal');
        this.modal.init();
        this.modal.inited();

        let modalSize = typeof this.extraAttributes.modalSize !== typeof undefined ? this.extraAttributes.modalSize : 'lg';

        this.modal.setSize(modalSize);
        this.modal.initForm(formId);

        if (typeof response._pageTitle !== typeof undefined) {
            this.modal.setTitle(response._pageTitle);
        } else {
            this.modal.setTitle(this.element.title);
        }

        let modalContent = document.createElement('div');

        this.hm.app.addComponentsFromRemoteResponse(modalContent, response);

        this.modal.appendContent(modalContent);

        this.modal.addActions(response.actions.general);

        if (typeof response.actions.left !== typeof undefined) {
            this.modal.addActions(response.actions.left, 'left');
        }

        this.hm.app.initComponents(this.modal.element);

        this.hm.app.externalScriptsFromRemoteResponse(response);
    }
});

module.exports = popupEdit;